import Vue from "vue";
import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
// Optional. When using scrollOverflow:true
import "fullpage.js/vendors/scrolloverflow";

// Optional. When using fullpage extensions
//import './fullpage.scrollHorizontally.min'
import VueFullPage from "vue-fullpage.js";
import App from "./App.vue";
import VueA11yDialog from "vue-a11y-dialog";
// Import the styles directly. (Or you could add them via script tags.)

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
//highcharts
import HighchartsVue from "highcharts-vue";

// main css file
import "./assets/css/main.css";

import './registerServiceWorker';

import './assets/css/fullpage.min.css';

Vue.config.productionTip = false;


Vue.use(VueFullPage);
Vue.use(BootstrapVue);
Vue.use(VueA11yDialog);
Vue.use(HighchartsVue);
Vue.config.productionTip = false;


new Vue({
  render: h => h(App)
}).$mount("#app");